import formatLocale from './locale.js';
var locale;
var format;
var formatPrefix;
defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale(definition) {
  locale = formatLocale(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}
export { defaultLocale as default, format, formatPrefix };
//# sourceMappingURL=defaultLocale.js.map
